import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { FiX } from "react-icons/fi";
import styles from "./AccessInfoModal.module.scss";
import Icon, { IconWrapper } from "components/Icon/Icon";
import Button from "components/Button/Button";

export default function AccessInfoModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleInformCpf = () => {
    onClose();
    navigate("/consultar-email/informar-cpf");
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "visible";
    return () => {
      document.body.style.overflow = "visible";
    };
  }, [isOpen]);

  return ReactDOM.createPortal(
    <div
      className={isOpen ? `${styles.dialog} ${styles.active}` : styles.dialog}
      onClick={onClose}
    >
      <div
        className={styles.content}
        onClick={(event) => event.stopPropagation()}
      >
        <IconWrapper onClick={onClose} className={styles.close}>
          <Icon>
            <FiX />
          </Icon>
        </IconWrapper>

        <img
          src="/access-info.png"
          alt="Tutora T.I.A"
          width={250}
          height={250}
          className={styles.image}
        />

        <div className={styles.text}>
          <h3 className={styles.title}>
            Seu acesso à plataforma mudou para melhor!
          </h3>
          <p>
            Alunos e professores do Piauí agora têm um{" "}
            <b>e-mail institucional exclusivo para entrar na plataforma.</b> É
            rápido e fácil! Basta informar seu CPF para descobrir seu novo
            e-mail.
          </p>

          <Button
            modifiers={["primary"]}
            onClick={handleInformCpf}
            style={{
              alignSelf: "flex-start",
              padding: "8px 16px",
              fontSize: "1.4rem",
            }}
          >
            Consultar meu e-mail
          </Button>
        </div>
      </div>
    </div>,
    document.getElementById("modal_root"),
  );
}
